import script from "./HerramientasList.vue?vue&type=script&setup=true&lang=js"
export * from "./HerramientasList.vue?vue&type=script&setup=true&lang=js"

import "./HerramientasList.vue?vue&type=style&index=0&id=522d5082&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-522d5082"]])

export default __exports__